import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import ThemeSwitcher from './ThemeSwitcher';
import useConfiguration from '../../../../Hooks/UseConfiguration';
import useUser from '../../../../Hooks/UseUser';
import OrganisationSwitcher from '../Organisation/OrganisationSwitcher';
import useUserService from '../../../../Hooks/UseUserService';
import useLoadTracker from '../../../../Hooks/UseLoadTracker';
import ErrorUtils from '../../../../Utils/ErrorUtils';
import Avatar from '@cb/solaris-react/Components/Content/Avatar';
import Button from '@cb/solaris-react/Components/Interactive/Button/Button';
import InlineSpinner from '@cb/solaris-react/Components/Loading/InlineSpinner';
import ButtonLink from '@cb/solaris-react/Components/Navigation/ButtonLink';
import { Scheme, Size, Variant } from '@cb/solaris-react/Constants/System';
import { useHistory } from 'react-router-dom';
import { GlobalRoutes } from '../../../../Utils/NavigationUtils';
export default function ProfileSlideout(props) {
    const configuration = useConfiguration();
    const { user, error } = useUser();
    const history = useHistory();
    const { addLoader, removeLoader, isLoading } = useLoadTracker();
    const userService = useUserService();
    const handleProfileButtonClicked = async (e) => {
        e.preventDefault();
        const loader = addLoader();
        try {
            await userService.loginToAuthService();
            window.open(configuration.serviceConfig.authServiceApiRoot + '/profile', '_blank');
            removeLoader(loader);
        }
        catch (err) {
            ErrorUtils.handleError(err, 'Error logging in to auth service', () => {
                removeLoader(loader);
            });
        }
    };
    const logout = () => {
        history.push(GlobalRoutes.Logout);
    };
    return (_jsxs(StyledProfileSlideout, { children: [_jsxs(StyledCloseSection, { children: [_jsx(ThemeSwitcher, {}), _jsx(StyledCloseButton, { onClick: props.close, scheme: Scheme.shade6, children: "Close" })] }), error ? (_jsx(StyledErrorText, { children: "An error occurred fetching user information. Contact support if the issue persists." })) : null, user === undefined && !error ? (_jsxs(_Fragment, { children: [_jsx(StyledLoadingText, { children: "Loading user information" }), _jsx(InlineSpinner, { size: Size.small })] })) : null, user && (_jsxs(_Fragment, { children: [_jsx(Avatar, { userId: user.id, name: user.name, description: user.email, src: user.picture }), _jsxs(StyledButtonLink, { href: configuration.serviceConfig.authServiceApiRoot + '/profile', target: '_blank', rel: "noreferrer", variant: Variant.quiet, size: Size.small, onClick: handleProfileButtonClicked, disabled: isLoading, children: ["Update Details or Password ", isLoading && _jsx(InlineSpinner, { size: Size.small, margin: "0 0 0 8px" })] })] })), _jsx(OrganisationSwitcher, {}), _jsx(FullWidthButton, { onClick: logout, variant: Variant.solid, scheme: Scheme.shade6, children: "Logout" })] }));
}
const FullWidthButton = styled(Button) `
	align-self: stretch;
`;
const StyledButtonLink = styled(ButtonLink) `
	display: flex;
	align-items: center;
	font-size: ${(props) => props.theme.typography.sm};
`;
const StyledLoadingText = styled.p `
	font-size: ${(props) => props.theme.typography.md};
	margin-bottom: ${(props) => props.theme.spacing.xxs};
`;
const StyledErrorText = styled.p `
	font-size: ${(props) => props.theme.typography.md};
	color: ${(props) => props.theme.palette.error};
`;
const StyledProfileSlideout = styled.article `
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${(props) => props.theme.spacing.md};

	min-height: 100%;
`;
const StyledCloseButton = styled(Button) `
	margin-left: auto;
`;
const StyledCloseSection = styled.section `
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
`;
//# sourceMappingURL=ProfileSlideout.js.map